import { atom } from 'recoil';

export const isRestrictedState = atom({
	key: 'isRestrictedState',
	default: false,
});
